const modals = document.querySelectorAll("[data-modal-trigger]");
const body = document.getElementsByTagName('body');
const overlay = document.getElementById('modal-overlay-backdrop');

const modalContainers = document.querySelectorAll('.modal-container')

modals.forEach(function (trigger) {
  trigger.addEventListener('click', function (event) {
    const modals = document.querySelectorAll('.modal')
    const modal = document.getElementById(trigger.dataset.modalTrigger);

    const body = document.getElementsByTagName('body')[0];

    try 
    {
      
      modals.forEach(function(m){
        m.classList.remove('open');
        overlay.classList.remove('visible')
        body.classList.remove('modal-open')
      })
      overlay.classList.add('visible')
      modal.classList.add('open');
      body.classList.add('modal-open')
      const exits = body.querySelectorAll('.modal-exit');
      modals.forEach(function(m) {
        m.addEventListener('click', event => {
          let isClickInside = false
          modalContainers.forEach( function(elem) {
            isClickInside = elem.contains(event.target) ? true : isClickInside
          })
          if (!isClickInside) {
            const modals = document.querySelectorAll('.modal')
            modals.forEach( function(m){
              m.classList.remove('open')
            })
            overlay.classList.remove('visible')
            document.body.classList.remove('modal-open')
          }
        })
      })
      exits.forEach(function (exit) {
        exit.addEventListener('click', function (event) {
          event.preventDefault();
          modal.classList.remove('open');
          overlay.classList.remove('visible')
          body.classList.remove('modal-open')
        });
      });
    }catch(err) {
          console.error("Error nw-ask-expert-modal: " + err.message);
    }
    
  });
});
